<template>
  <div class="viq-board-report">
    <!-- Step indicator -->
    <div class="viq-board-report__steps">
      <div
        v-for="(step, i) in steps"
        :key="i"
        class="viq-board-report__step"
        :class="{
          'viq-board-report__step--active': reportStep === i + 1,
          'viq-board-report__step--done': reportStep > i + 1,
        }"
      >
        <span class="viq-board-report__step-num">{{ i + 1 }}</span>
        <span class="viq-board-report__step-label">{{ step }}</span>
      </div>
    </div>

    <!-- Step 1: Briefing -->
    <ViqReportBriefing v-if="reportStep === 1" @submit="handleBriefing" />

    <!-- Step 2: Outline Editor -->
    <ViqReportOutlineEditor
      v-else-if="reportStep === 2"
      :outline="reportOutline"
      @confirm="handleOutlineConfirm"
      @refine="handleOutlineRefine"
    />

    <!-- Step 3: Section Streaming -->
    <ViqReportSectionStream v-else-if="reportStep === 3" :sections="reportSections" />

    <!-- Step 4: Executive Summary -->
    <ViqReportExecSummary
      v-else-if="reportStep === 4"
      :summary="reportExecSummary"
      :sections="reportSections"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ViqBoardReport",
  components: {
    ViqReportBriefing: () => import("./ViqReportBriefing"),
    ViqReportOutlineEditor: () => import("./ViqReportOutlineEditor"),
    ViqReportSectionStream: () => import("./ViqReportSectionStream"),
    ViqReportExecSummary: () => import("./ViqReportExecSummary"),
  },
  data() {
    return {
      steps: ["Briefing", "Outline", "Generate", "Summary"],
    };
  },
  computed: {
    ...mapState("Viq", [
      "reportStep",
      "reportOutline",
      "reportSections",
      "reportExecSummary",
      "activeConversation",
    ]),
  },
  methods: {
    async handleBriefing(topic) {
      await this.$store.dispatch("Viq/generateBriefing", {
        topic,
        reportType: "board",
      });
    },
    handleOutlineConfirm(sections) {
      this.$store.dispatch("Viq/streamReport", {
        conversationId: this.activeConversation?.id,
        sections,
      });
    },
    async handleOutlineRefine(instructions) {
      await this.$store.dispatch("Viq/refineReport", {
        conversationId: this.activeConversation?.id,
        instructions,
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/viq.scss";

.viq-board-report {
  max-width: 720px;
  margin: 0 auto;
  width: 100%;

  &__steps {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: $viq-space-lg;
    margin-bottom: $viq-space-xl;
    padding: $viq-space-md 0;
  }

  &__step {
    display: flex;
    align-items: center;
    gap: $viq-space-sm;

    &-num {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      background: $viq-bg-secondary;
      color: $viq-text-secondary;
      font-size: $viq-font-sm;
      font-weight: 700;
      border: 2px solid $viq-border;
    }

    &-label {
      font-size: $viq-font-sm;
      font-weight: 600;
      color: $viq-text-secondary;
    }

    &--active {
      .viq-board-report__step-num {
        background: $viq-accent;
        color: #fff;
        border-color: $viq-accent;
      }
      .viq-board-report__step-label {
        color: $viq-accent;
      }
    }

    &--done {
      .viq-board-report__step-num {
        background: $viq-success;
        color: #fff;
        border-color: $viq-success;
      }
      .viq-board-report__step-label {
        color: $viq-success;
      }
    }
  }
}
</style>
